var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasMore || _vm.loading),expression:"hasMore || loading"}],ref:"sentinel",staticClass:"auto-load"},[_vm._m(0),_c('span',{staticClass:"auto-load-text"},[_vm._v("Indlæser flere opskrifter…")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auto-load-spinner",attrs:{"aria-hidden":"true"}},[_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }